export default function NotFound(): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="font-bold mb-4">404 - Not Found</h1>
      <button onClick={() => (window.location.href = "/")} className="mt-5">
        Login in the system
      </button>
    </div>
  );
}
